import { graphqlApolloClient } from "../graphql-apollo-client"
import {
  CREATE_MINISTRATION_PLAN,
  UPDATE_MINISTRATION_PLAN,
  CREATE_MINISTRATION_PERIOD,
  GET_MINISTRATION_PLAN_AND_PERIOD_BY_SUBMISSION
} from "./graphql"

export const ministrationPlanService = () => {
  const createMinistrationPeriod = async ({ ministrationPeriod, ministrationPlanId }) => {
    const { data } = await graphqlApolloClient.mutate({
      mutation: CREATE_MINISTRATION_PERIOD,
      variables: {
        ministrationPlanId,
        createMinistrationPeriod: { ...ministrationPeriod, id: undefined }
      }
    })
    return data?.CreateMinistrationPeriod
  }

  const getMinistrationsPlanBySubmission = async ({ submissionId }) => {
    const { data } = await graphqlApolloClient.query({
      query: GET_MINISTRATION_PLAN_AND_PERIOD_BY_SUBMISSION,
      fetchPolicy: "network-only",
      variables: { submissionId }
    })

    return data?.getMinistrationsPlanWithMinistrationsAndPeriodsBySubmission
  }

  const editMinistrationPlan = async ({ ministrationPlan, submissionId }) => {
    if (ministrationPlan.id) {
      const { data } = await graphqlApolloClient.mutate({
        mutation: UPDATE_MINISTRATION_PLAN,
        variables: {
          ministrationPlanId: ministrationPlan?.id,
          createMinistrationPlanData: { ...ministrationPlan, id: undefined }
        }
      })
      return data?.UpdateMinistrationPlan
    } else {
      const { data } = await graphqlApolloClient.mutate({
        mutation: CREATE_MINISTRATION_PLAN,
        variables: {
          submissionId,
          createMinistrationPlanData: { ...ministrationPlan, id: undefined }
        }
      })
      return data?.CreateMinistrationPlan
    }
  }

  const getMinistrationPeriods = async () => null

  return {
    editMinistrationPlan,
    getMinistrationPeriods,
    createMinistrationPeriod,
    getMinistrationsPlanBySubmission
  }
}
